import apiClient from './apiClient';

export const heroIntegrationApi = {
  get: async () => {
    const response = await apiClient.get('/hero-integration');
    return response.data;
  },

  save: async (data) => {
    const response = await apiClient.post('/hero-integration', data);
    return response.data;
  },

  delete: async () => {
    const response = await apiClient.delete('/hero-integration');
    return response.data;
  },

  testConnection: async () => {
    const response = await apiClient.post('/hero-integration/test');
    return response.data;
  },

  triggerSync: async () => {
    const response = await apiClient.post('/hero-integration/sync');
    return response.data;
  },

  getStatus: async () => {
    const response = await apiClient.get('/hero-integration/status');
    return response.data;
  },

  getLogs: async (params = {}) => {
    const response = await apiClient.get('/hero-integration/logs', { params });
    return response.data;
  },
};
